<template>
  <div class="badge-chat-notification">{{ notification }}</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BadgeChatNotification",

  data: () => ({
    notification: "",
  }),

  watch: {
    "back4App.branchesMessages": {
      immediate: true,
      deep: true,
      handler(branchesMessages) {
        if (_.isEmpty(branchesMessages)) {
          return;
        }

        this.setTotalNotificationsCount(branchesMessages);
      },
    },
  },

  computed: {
    ...mapGetters({
      back4App: "Business/back4App",
    }),
  },

  methods: {
    /**
     * Handle on set notifications count in debounce
     * @return {void}
     */
    setTotalNotificationsCount: _.debounce(function (branchesMessages) {
      let counter = 0;
      Object.values(branchesMessages).forEach((list) => {
        counter += list.count;
      });

      if (counter) {
        this.notification = counter > 9 ? "+9" : counter;
      }
    }, 300),
  },
};
</script>

<style lang="scss" scoped src="./styles.scss" />
